import { Typography } from '@mui/material';

const CoPLogo = () => (
    <Typography sx={{ fontWeight: 600, fontSize: 20, color: '#120E43', marginLeft: 10 }}>Community of Practice</Typography>
);

export default CoPLogo;
